export default{
    coaches(state){
        return state.coaches
    },
    hasCoaches(state){
        return state.coaches && state.coaches.length > 0
    },
    newCoachStatus(state,getters,rootState,rootGetters){
        let coaches = getters.coaches
      
        return coaches.some(coach => coach.id == rootGetters.userId)
    },
    shouldFetch(state){
        let currentTime = new Date().getTime();
        let shouldFetch = (currentTime - state.lastFetched)/1000
        return shouldFetch > 60
    }
}